module.exports = __webpack_public_path__ + "static/media/hover.ee45c3a8.svg";


//////////////////
// WEBPACK FOOTER
// /src/globals/images/hover.svg
// module id = 1716
// module chunks = 0